import { useState } from "react";
import { Select, Switch } from "antd";
import availabilityTimeOptions from "../../utils/availabilityTimeOptions";

const DayAvailability = ({ value, onChange }) => {
  const [Enabled, setEnabled] = useState(value?.Enabled || false);
  const [Start] = useState(value?.Start || "09:00");
  const [End] = useState(value?.End || "17:00");
  const [valid] = useState(value?.valid || true);
  const Day = value.Day;

  const triggerChange = (changedValue) => {
    onChange?.({
      Enabled,
      Day,
      valid,
      ...value,
      ...changedValue,
    });
  };

  const changeEnabled = (enabled) => {
    const valid = !enabled ? true : Start < End;
    setEnabled(enabled);
    triggerChange({
      Enabled: enabled,
      valid: valid,
      Start: Start,
      End: End,
    });
  };

  const changeStart = (start) => {
    const valid = !Enabled ? true : start < End;

    triggerChange({
      Start: start,
      valid: valid,
    });
  };

  const changeEnd = (end) => {
    const valid = !Enabled ? true : end > Start;

    triggerChange({
      End: end,
      valid: valid,
    });
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ flex: "0 0 50px" }}>
        <Switch defaultChecked={Enabled} onChange={changeEnabled} />
      </div>
      <div style={{ flex: "1 1 auto", padding: "0 5px" }}>
        <Select
          disabled={!Enabled}
          defaultValue={Start}
          options={availabilityTimeOptions()}
          onChange={changeStart}
        />
      </div>
      <div style={{ flex: "1 1 auto", padding: "0 5px" }}>
        <Select
          disabled={!Enabled}
          defaultValue={End}
          options={availabilityTimeOptions()}
          onChange={changeEnd}
        />
      </div>
    </div>
  );
};

export default DayAvailability;
